module.exports = __webpack_public_path__ + "img/KSC02807.a9c7a37c.jpg";